import { postRequest, getRequest } from 'utils/http';
import { BACKEND_API_VPLUS, SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB } from 'global/environment';
import { cui } from 'components';
import sha256 from 'crypto-js/sha256';
import { v4 as uuidv4 } from 'uuid';
import cryptoJs from 'crypto-js';
import { CommonService } from './CommonService';
import { DEFAULT_LOCALE } from 'store/constants';

const baseURL = BACKEND_API_VPLUS;
const uuid = uuidv4()
const msisdn = localStorage.getItem("mobile") ? localStorage.getItem("mobile") : ""
const partnerCode = "WEB_MYVNPT"
const secretKey = SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB;
// 123123

const setHeaders = () => {
  const Authorization = "Bearer a60bd62fed0cf1076e93af76114f196bd9c5a48155b2bac88afe15c49595414b";
  const setHeaders = {
    Authorization,
    Language: localStorage.getItem('language') ? (localStorage.getItem('language') === "en-US" ? "en" : localStorage.getItem('language') ) : DEFAULT_LOCALE,
    "Accept-Language": localStorage.getItem('language') ? (localStorage.getItem('language') === "en-US" ? "en" : localStorage.getItem('language') ) : DEFAULT_LOCALE,
  }
  return setHeaders;
};

const setRequest = () => {
  const secureCode = sha256(uuid + "|" + (msisdn === localStorage.getItem("mobile") ? msisdn : localStorage.getItem("mobile") ? localStorage.getItem("mobile"): "") + "|" + partnerCode + "|" + secretKey).toString(cryptoJs.enc.Hex);
  const data = {
    token: localStorage.getItem('vplus_TokenHoiVienEsc') ? localStorage.getItem('vplus_TokenHoiVienEsc') : "",
    secureCode: secureCode,
    requestId: uuid,
    partnerCode: partnerCode,
    msisdn: localStorage.getItem('mobile') ? localStorage.getItem('mobile') : ""
  }
  return data
}

export const VPlusService = {
  getTokenHoiVien: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getTokenHoiVien`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    if (msisdn === "" || msisdn !== request.msisdn) {
      dataHandle = {
        ...dataHandle,
        msisdn: data.msisdn,
        secureCode: sha256(uuid + "|" + data.msisdn + "|" + partnerCode + "|" + secretKey).toString(cryptoJs.enc.Hex)
      }
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getDSChuongTrinhUuDaiDoiDiem: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getDSChuongTrinhUuDaiDoiDiem`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  
  getLayThongTinChungMobile: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getLayThongTinChungMobileV2`;
    let request = setRequest()
    let dataHandle = {
      ...request,
      ...data,
    }
    if (msisdn === "" || msisdn !== CommonService.convert0to84(data.msisdn)) {
      dataHandle = {
        ...dataHandle,
        msisdn: CommonService.convert0to84(data.msisdn),
        secureCode: sha256(uuid + "|" + CommonService.convert0to84(data.msisdn) + "|" + partnerCode + "|" + secretKey).toString(cryptoJs.enc.Hex)
      }
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  getDanhMucUuDai: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/catalogDiscounts`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    if (msisdn === "" || (data.msisdn && msisdn !== CommonService.convert0to84(data.msisdn))) {
      dataHandle = {
        ...dataHandle,
        msisdn: data.msisdn,
        secureCode: sha256(uuid + "|" + data.msisdn + "|" + partnerCode + "|" + secretKey).toString(cryptoJs.enc.Hex)
      }
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  // get

  getThongTinChuongTrinhUuDai: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiXemThongTinChuongTrinhUuDai`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getLichSuSuDungUuDaiHoiVien: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiLichSuSuDungUuDaiHoiVienSudung`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getDSChuongTrinhUuDaiQuaTang: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiDSChuongTrinhUuDaiQuaTang`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  // ------START OTP------
  apiKiemTraNhanUuDai: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiKiemTraNhanUuDai`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  apiNhanUuDaiWithOTP: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiNhanUuDaiWithOTP`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getTheoDoiNhanQua: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiTheodoinhanqua`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getDmDiaBan: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apidmdiaban`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getGioiThieu: function (data, config, successCallback, failCallback) {
    const URL = `${baseURL}/apiGetGioiThieu`;
    return postRequest(URL, data, {
      headers: {...setHeaders(), ...config.headers}
    }, successCallback, failCallback);
  },

  getDiaBanNoLogin: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apidmdiaban`;
    return postRequest(URL, data, {headers: setHeaders()}, successCallback, failCallback);
  },

  getDSLinhVucKinhDoanh: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/Api_LayDSLinhVucKinhDoanh`;
    let dataHandle = {
      ...data,
      ...setRequest()
    }
    // {byPass: 1, requestId: uuidv4()}   trường hợp truyền request API như này ra Response khác và ít loại hơn
    return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
  },

  getCaptcha: function (successCallback, failCallback) {
    const URL = `${baseURL}/apiGetCaptcha`;
    return postRequest(URL, setRequest(), {headers: setHeaders()}, successCallback, failCallback);
  },

  apiDangKyDoiTacLienKet: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/Api_DangKyDoiTacLienKet`;
    let dataHandle = {
      ...data,
      ...setRequest()
    }
    return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
  },

  getDSChuongTrinhUuDaiUuDaiHoiVien: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/Api_DSChuongTrinhUuDaiUuDaiHoiVien`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getXemChiTietSanPhamDoiTac: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiDSChuongTrinhSanPhamTheoDoiTac`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  apiTheodoinhanqua: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiTheodoinhanqua`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  getKiemTraDanhGiaChuongTrinhUuDai:  function (data, successCallback, failCallback) {
    const URL = `${baseURL}/KiemTraDanhGiaChuongTrinhUuDai`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getConfigPromotionPoints: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getConfigPromotionPoints`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getLichSuDiem:  function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getLichSuDiemNewV2`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  
  getChiTietDiemThongTinBoSung:  function (data, successCallback, failCallback) {
    const URL = `${baseURL}/getChiTietDiemThongTinBoSung`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
  getLayDanhSachDichVuSuDung:  function (successCallback, failCallback) {
    const URL = `${baseURL}/apiLayDanhSachDichVuSuDung`;
    let request = setRequest()
    let dataHandle = {
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  apiDanhGiaChuongTrinhUuDai: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiDanhGiaChuongTrinhUuDai`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getThongTinChuongTrinhUuDaiV1: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/api_XemThongTinChuongTrinhUuDai_v1`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  apiCapNhatEmail: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/capNhatEmail`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },


  apiTangDiem: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/TangDiem`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiTangDiemSendOTP: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/TangDiemSendOTP`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiTangDiemVerify: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/TangDiemVerify`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiTangDiemThongTin: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/TangDiemThongTin`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiCancelMember: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/cancelMember`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
      secureCode: sha256(uuid + "|" + request.msisdn + "|"+ request?.token + "|" + data?.otpValue + "|" + secretKey).toString(cryptoJs.enc.Hex)
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiRegisterMember: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/registerMember`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
      secureCode: sha256(uuid + "|" + request.msisdn + "|" + (data?.otpValue ? data?.otpValue : "null") + "|" + secretKey).toString(cryptoJs.enc.Hex)
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiVerifyMemberInfo: function (data, successCallback, failCallback, options = {}) {
    const URL = `${baseURL}/verifyMemberInfo`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request,
      secureCode: sha256(uuid + "|" + request.msisdn + "|" + (data?.otpValue ? data?.otpValue : "null") + "|" + secretKey).toString(cryptoJs.enc.Hex)
    }
    return postRequest(URL, dataHandle, { headers: {...setHeaders(), ...options.headers} }, successCallback, failCallback);
  },

  apiXemChiTietSanPhamDoiTac: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/apiXemChiTietSanPhamDoiTac`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequest(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
};

